import type { EditIntensity } from "./types";

interface ToneOption {
  id: string;
  label: string;
  emoji: string;
  description: string;
}

interface QuickAction {
  label: string;
  emoji: string;
  prompt: string;
}

interface EditIntensityOption {
  id: EditIntensity;
  label: string;
  description: string;
}

interface StyleGuideOption {
  id: string;
  label: string;
  description: string;
}

export const MAX_HISTORY = 10;
export const MAX_EDITABLE_WORDS = 1200;
export const LARGE_SELECTION_WARNING_THRESHOLD = 1000;

export const TONE_OPTIONS: ToneOption[] = [
  {
    id: "Professional",
    label: "Professional",
    emoji: "\u{1F4BC}",
    description: "Formal, objective, and business-appropriate",
  },
  {
    id: "Casual",
    label: "Casual",
    emoji: "\u{1F60A}",
    description: "Relaxed, friendly, and conversational",
  },
  {
    id: "Academic",
    label: "Academic",
    emoji: "\u{1F393}",
    description: "Scholarly, analytical, and well-structured",
  },
  {
    id: "Persuasive",
    label: "Persuasive",
    emoji: "\u{1F3AF}",
    description: "Compelling, convincing, and action-oriented",
  },
  {
    id: "Concise",
    label: "Concise",
    emoji: "\u2702\uFE0F",
    description: "Brief, clear, and to the point",
  },
  {
    id: "Creative",
    label: "Creative",
    emoji: "\u{1F3A8}",
    description: "Imaginative, engaging, and expressive",
  },
];

export const QUICK_ACTIONS: QuickAction[] = [
  {
    label: "Make Shorter",
    emoji: "\u2702\uFE0F",
    prompt: "Shorten this text while preserving all key information",
  },
  {
    label: "Make Longer",
    emoji: "\u{1F4DD}",
    prompt: "Expand this text with more detail, examples, and explanation",
  },
  {
    label: "Fix Grammar",
    emoji: "\u{1F527}",
    prompt: "Fix all grammar, spelling, and punctuation errors",
  },
  {
    label: "Simplify",
    emoji: "\u{1F4A1}",
    prompt: "Simplify the language to make it easier to understand",
  },
  {
    label: "Add Examples",
    emoji: "\u{1F4CC}",
    prompt: "Add relevant examples to illustrate the key points",
  },
  {
    label: "More Formal",
    emoji: "\u{1F454}",
    prompt: "Make this text more formal and professional",
  },
];

export const EDIT_INTENSITY_OPTIONS: EditIntensityOption[] = [
  { id: "light", label: "Light", description: "Fix errors, preserve voice" },
  { id: "medium", label: "Medium", description: "Improve clarity & flow" },
  { id: "heavy", label: "Heavy", description: "Full rewrite for impact" },
];

export const STYLE_GUIDE_OPTIONS: StyleGuideOption[] = [
  { id: "", label: "None", description: "No specific style guide applied" },
  {
    id: "AP",
    label: "AP",
    description:
      "Associated Press format, used in journalism and news writing",
  },
  {
    id: "Chicago",
    label: "Chicago",
    description:
      "Chicago Manual of Style, used in book publishing and humanities",
  },
  {
    id: "MLA",
    label: "MLA",
    description:
      "Modern Language Association, used in literature, arts, and humanities",
  },
  {
    id: "APA",
    label: "APA",
    description:
      "American Psychological Association, used in social sciences and education",
  },
];
